import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { initGTM, trackPageView } from './services/gtm';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
// Initialize Google Tag Manager if REACT_APP_GTM_ID is set
initGTM();
// Track initial page view once and signal Layout to skip its first fire
trackPageView();
if (typeof window !== 'undefined') {
  window.__gtm_initial_tracked = true;
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
